import ServiceLandingLayout from '../components/ServiceLandingLayout';

export default function EpoodPage() {
  return <ServiceLandingLayout translationKey="epood_landing" proofLink="/case-studies/ecommerce-performance" />;
}
